import { LinkedInPlatform, LinkedInCampaignStatus } from './enums';

export interface PlatformField {
  platformField: string;
  label: string;
  required: boolean;
}

export const AIMFOX_FIELDS: PlatformField[] = [
  { platformField: 'profile_url', label: 'LinkedIn URL', required: true },
  { platformField: 'first_name', label: 'First Name', required: false },
  { platformField: 'last_name', label: 'Last Name', required: false },
  { platformField: 'company', label: 'Company Name', required: false },
  { platformField: 'job_title', label: 'Job Title', required: false },
];

export const HEYREACH_FIELDS: PlatformField[] = [
  { platformField: 'profileUrl', label: 'LinkedIn URL', required: true },
  { platformField: 'firstName', label: 'First Name', required: true },
  { platformField: 'lastName', label: 'Last Name', required: true },
  { platformField: 'emailAddress', label: 'Email', required: false },
  { platformField: 'companyName', label: 'Company Name', required: false },
  { platformField: 'position', label: 'Job Position', required: false },
  { platformField: 'location', label: 'Location', required: false },
];

export const getPlatformFields = (platform: LinkedInPlatform): PlatformField[] =>
  platform === LinkedInPlatform.HeyReach ? HEYREACH_FIELDS : AIMFOX_FIELDS;

// Maps every platform field key to the expected SH field label for default pre-population
export const PLATFORM_FIELD_TO_SH_LABEL: Record<string, string> = {
  // Aimfox
  profile_url: 'LinkedIn URL',
  first_name: 'First Name',
  last_name: 'Last Name',
  company: 'Company',
  job_title: 'Job Title',
  // HeyReach
  profileUrl: 'LinkedIn URL',
  firstName: 'First Name',
  lastName: 'Last Name',
  emailAddress: 'Email',
  companyName: 'Company',
  position: 'Job Title',
  location: 'Location',
};

export const PLATFORM_CONFIG = {
  [LinkedInPlatform.Aimfox]: {
    name: 'Aimfox',
    apiKeyPlaceholder: 'Enter your Aimfox API key',
    apiKeyHelpPath: 'Aimfox > Workspace Settings > API keys',
    apiKeyHelpUrl: 'https://app.aimfox.com/settings/api-keys',
    signUpUrl: 'https://app.aimfox.com/auth/register',
    campaignCreateUrl: 'https://app.aimfox.com/campaigns/new',
    hasLinkedInAccountSelector: false,
    showProspectCounts: true,
    eligibleStatuses: [LinkedInCampaignStatus.Active, LinkedInCampaignStatus.Paused, LinkedInCampaignStatus.Completed],
    ineligibleStatuses: [LinkedInCampaignStatus.Init, LinkedInCampaignStatus.Scheduled],
    campaignSelectSubtitle: 'Select an Aimfox campaign to push prospects into.',
    mappingColumnHeader: 'Aimfox Merge Tag',
  },
  [LinkedInPlatform.HeyReach]: {
    name: 'HeyReach',
    apiKeyPlaceholder: 'Enter your HeyReach API key',
    apiKeyHelpPath: 'HeyReach > Settings > Integrations > API key',
    apiKeyHelpUrl: 'https://app.heyreach.io/app/organization-settings',
    signUpUrl: 'https://heyreach.io/?via=saleshandy',
    campaignCreateUrl: 'https://app.heyreach.io/app/campaigns',
    campaignViewUrlBase: 'https://app.heyreach.io/app/campaign/view',
    campaignViewUrlSuffix: '/performance',
    hasLinkedInAccountSelector: true,
    showProspectCounts: false,
    eligibleStatuses: [LinkedInCampaignStatus.Active, LinkedInCampaignStatus.Paused, LinkedInCampaignStatus.Completed],
    ineligibleStatuses: [LinkedInCampaignStatus.Draft, LinkedInCampaignStatus.Scheduled, LinkedInCampaignStatus.Starting, LinkedInCampaignStatus.Canceled, LinkedInCampaignStatus.Cancelled, LinkedInCampaignStatus.Failed],
    campaignSelectSubtitle: 'Select HeyReach campaign and choose LinkedIn account.',
    mappingColumnHeader: 'HeyReach Field',
  },
};

export const REQUEST_PLATFORM_URL =
  'https://docs.google.com/forms/d/1xBaLmiWPLiWrZC49cjcckAsUZQYXm0Pfkjn5aVY-70U/edit?usp=sharing_eil_se_dm&ts=69aebd2e';
